var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogInFilled = function SvgLogInFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.015V.474a7 7 0 0 1 2.465 1.59l3.484 3.486a6.95 6.95 0 0 1 1.591 2.464H15a1 1 0 0 1-1-1m7.976 3H15c-1.654 0-3-1.346-3-3V.038c-.161-.011-.322-.024-.485-.024H7a5.007 5.007 0 0 0-5 5V14h8.398l-1.293-1.293a.999.999 0 1 1 1.414-1.414l1.613 1.614a2.965 2.965 0 0 1 0 4.187l-1.613 1.614a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L10.398 16H2v3.015c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V10.5c0-.163-.013-.325-.024-.486"
  })));
};
export default SvgLogInFilled;